import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import JsonData from '../data/data.json';
import 'swiper/css';
import 'swiper/css/autoplay';

const ClientLogos = () => {
    const logos = JsonData.clientLogos;

    return (
        <div className="client-logos-container">
            <div className="container">
                <div className="section-title">
                    <h2>Powering Conversations for Top Brands</h2>
                </div>
                <Swiper
                    modules={[Autoplay]}
                    slidesPerView={5}
                    spaceBetween={30}
                    loop={true}
                    autoplay={{ delay: 2000, disableOnInteraction: false }}
                    breakpoints={{
                        320: { slidesPerView: 2 },
                        640: { slidesPerView: 3 },
                        768: { slidesPerView: 4 },
                        1024: { slidesPerView: 5 },
                    }}
                    className="px-4"
                >
                    {logos.map((logo, index) => (
                        <SwiperSlide key={index} className="client-logo-slide">
                            <img src={logo.src} alt={logo.name} title={logo.name} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default ClientLogos;